import { render, staticRenderFns } from "./categoryfore.vue?vue&type=template&id=62e45fb6&scoped=true&"
import script from "./categoryfore.vue?vue&type=script&lang=js&"
export * from "./categoryfore.vue?vue&type=script&lang=js&"
import style0 from "./categoryfore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e45fb6",
  null
  
)

export default component.exports